import { useCallback, useContext } from 'react';
import { BlockKitContext } from '../contexts/context';
export const usePermissions = () => {
    var _a, _b, _c;
    const context = useContext(BlockKitContext);
    const permissions = (_c = (_b = (_a = context === null || context === void 0 ? void 0 : context.appContext) === null || _a === void 0 ? void 0 : _a.authInfo) === null || _b === void 0 ? void 0 : _b.user) === null || _c === void 0 ? void 0 : _c.permissions;
    const checkPermissions = useCallback((testPermissions) => {
        const regExp = new RegExp(testPermissions.join('|'));
        return Boolean(permissions === null || permissions === void 0 ? void 0 : permissions.some((permission) => regExp.test(permission)));
    }, [permissions]);
    return { permissions, checkPermissions };
};
//# sourceMappingURL=use-permissions.js.map